<template>
  <q-input
    :model-value="modelValue"
    :placeholder="defaultPhone ? `${defaultPhone} (Auto)` : placeholder"
    :disable="disable"
    :input-class="{'dark-placeholder': !!defaultPhone}"
    :error="!disable && !checkMobilePhoneValid(modelValue || defaultPhone)"
    :error-message="invalidMobileError"
    dense
    outlined
    hide-bottom-space
    clearable
    @update:model-value="onSelectValue($event)"
    @focus="$emit('focus')"
  >
    <template v-if="mobileMode" #append>
      <q-btn
        dense
        flat
        icon="mdi-dots-vertical"
        @click="$refs.menu.open()"
      />
    </template>

    <responsive-menu
      ref="menu"
      toolbar-title="Suggested Phones"
      no-parent-event="mobile"
      force-on-mobile
      autoclose
      fit
      max-width="450px"
      :breakpoint="1024"
    >
      <template v-if="!disable && !modelValue && defaultPhone && prefillHint">
        <q-item-wrapper
          icon="mdi-phone-sync"
          label-class="text-bold text-blue-grey-8"
          :label="prefillHint"
        />
        <q-separator inset />
      </template>
      <template v-if="suggestions.length > 0">
        <q-list dense style="min-width: 250px;">
          <q-item-label header class="text-bold">
            Suggested Phone Numbers
          </q-item-label>
          <template v-for="(line, key) in suggestions" :key="key">
            <q-item-wrapper
              v-if="typeof line === 'string'"
              :label="line"
              label-class="text-bold"
            />
            <q-item-wrapper
              v-else
              :active="line.full_phone === modelValue"
              clickable
              @click="onSelectValue(line.full_phone)"
            >
              <q-item-label>{{ line.full_phone }}</q-item-label>

              <template v-if="line.field_name" #after>
                <q-item-section side>
                  <q-item-label>{{ line.field_name }}</q-item-label>
                </q-item-section>
              </template>
            </q-item-wrapper>
          </template>
        </q-list>
      </template>
      <q-item-wrapper
        v-else
        dense
        label="No suggested phone numbers to display"
        label-class="text-bold"
      />
    </responsive-menu>
  </q-input>
</template>

<script>
/**
 * MobilePhoneInput can provide suggestions for applicable mobile numbers
 * Also highlights in red if mobile number *might* be invalid
 * Please refer to ReminderList for details
 */
export default {
  props: {
    modelValue: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: 'Enter mobile number...'
    },
    disable: {
      type: Boolean,
      default: false
    },
    defaultPhone: {
      type: String,
      default: null
    },
    prefillHint: {
      type: String,
      default: 'Mobile is set to automatically prefill. Changing the mobile number on the client profile will automatically reflect onto this reminder.'
    },
    suggestions: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  emits: ['focus', 'update:modelValue'],
  computed: {
    mobileMode () {
      return this.$q.screen.width < 1024 || this.$q.platform.is.mobile
    },
    invalidMobileError () {
      if (!this.modelValue && !this.defaultPhone) {
        return 'Please enter a valid mobile number'
      }
      return 'This mobile number might be invalid'
    }
  },
  methods: {
    onSelectValue (val) {
      this.$emit('update:modelValue', val)
    }
  }
}
</script>
